let environment = {
  production: false,
  url: 'https://api.farmacia.puntosalud.ar/api/v1/nuvalid-farmacia',
};

export { environment };
